import { FC } from 'react';

import { Text, VSpacing } from '@hh.ru/magritte-ui';
import { PlayFilledSize24 } from '@hh.ru/magritte-ui/icon';

import useOnOffState from 'hooks/common/useOnOffState';
import useTrls from 'hooks/translation/useTrls';

import { BannerVideoModal } from 'components/common/BannerVideo/BannerVideoModal/BannerVideoModal';

import { BannerModerationInfo } from 'store/models/moderation';

import styles from 'components/Admin/ModerationList/CampaignModeration/Banner/Banner.module.less';

const TrlKeys = {
    title: 'admin.moderation.banner.video.title',
};

export const BannerVideo: FC<{ video: BannerModerationInfo['video']; bannerId: number }> = ({ video, bannerId }) => {
    const trls = useTrls();
    const [isBannerModalVideoVisible, setIsBannerModalVideoVisibleOn, setIsBannerModalVideoVisibleOff] =
        useOnOffState(false);

    if (!video) {
        return null;
    }

    const { thumbnailUrl, videoUrl, width, height } = video;

    return (
        <div>
            <Text typography="title-5-semibold">{trls(TrlKeys.title)}</Text>
            <VSpacing default={8} />
            <div>
                <div className={styles.bannerMediaPreviewWrapper} onClick={setIsBannerModalVideoVisibleOn}>
                    <img className={styles.media} src={thumbnailUrl} />
                    <div className={styles.bannerMediaExpand} data-qa={`banner-video-expand-${bannerId}`}>
                        <PlayFilledSize24 initialColor="contrast" />
                    </div>
                </div>
                <VSpacing default={8} />
                <div className={styles.mediaDimenshions}>
                    <Text Element="span" typography="label-3-regular" style="secondary">
                        {`${width} × ${height}`}
                    </Text>
                </div>
            </div>
            <BannerVideoModal
                visible={isBannerModalVideoVisible}
                onClose={setIsBannerModalVideoVisibleOff}
                videoUrl={videoUrl}
                thumbnailUrl={thumbnailUrl}
                width={width}
                height={height}
            />
        </div>
    );
};
